import posthog from "posthog-js";

declare global {
  interface Window {
    POSTHOG_API_KEY: string;
    POSTHOG_BROWSER_HOST: string;
  }
}

// posthog-js is a singleton. Once initialized by PostHogProvider in App.tsx,
// these helpers can be used anywhere (including non-component code like query hook callbacks).

function getPosthog() {
  return posthog.__loaded ? posthog : null;
}

function identifyUser(user: {
  id: number;
  email: string;
  organizationId?: number;
  organizationName?: string;
  plan?: string;
  organizationUserRole?: string;
}): void {
  const ph = getPosthog();
  if (!ph) {
    window.logger("%c[PostHog] identifyUser skipped - not loaded", "background-color: #FF76D2", { user });
    return;
  }

  window.logger("%c[PostHog] identifyUser", "background-color: #FF76D2", { user });
  ph.identify(String(user.id), {
    email: user.email,
    organization_id: user.organizationId,
    organization_name: user.organizationName,
    plan: user.plan,
    organization_user_role: user.organizationUserRole,
  });
}

function identifyOrganization(organization: {
  id: number;
  name?: string;
  plan?: string;
}): void {
  const ph = getPosthog();
  if (!ph) {
    window.logger("%c[PostHog] identifyOrganization skipped - not loaded", "background-color: #FF76D2", { organization });
    return;
  }

  window.logger("%c[PostHog] identifyOrganization", "background-color: #FF76D2", { organization });
  ph.group("organization", String(organization.id), {
    name: organization.name,
    plan: organization.plan,
  });
}

function trackEvent(event: string, properties?: Record<string, any>): void {
  const ph = getPosthog();
  if (!ph) {
    window.logger("%c[PostHog] trackEvent skipped - not loaded", "background-color: #FF76D2", { event, properties });
    return;
  }

  window.logger("%c[PostHog] trackEvent", "background-color: #FF76D2", { event, properties });
  ph.capture(event, properties);
}

function resetUser(): void {
  const ph = getPosthog();
  if (!ph) return;

  ph.reset();
}

export { identifyUser, identifyOrganization, trackEvent, resetUser };
export default posthog;
